import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import HeroSection from "./components/HeroSection";
import FeaturedSection from "./components/FeaturedSection";
import AmbiencePreview from "./components/AmbiencePreview";
import LocationsQuickView from "./components/LocationsQuickView";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Taco Street Digital - Authentic Mexican Street Food in Bengaluru |
          100% Halal
        </title>
        <meta
          name="description"
          content="Experience authentic Mexican street food in Bengaluru. 100% halal certified, fresh daily preparation, and vibrant dining atmosphere. Order now from Koramangala, Indiranagar, or Whitefield locations."
        />
        <meta
          name="keywords"
          content="Mexican food Bengaluru, halal tacos, street food, authentic Mexican, Koramangala restaurants, Indiranagar dining, Whitefield food"
        />
        <meta
          property="og:title"
          content="Taco Street Digital - Authentic Mexican Street Food"
        />
        <meta
          property="og:description"
          content="Real flavors, real fresh, real good times. Where street meets clean."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="min-h-screen flex flex-col bg-background">
        <Header />

        <main className="flex-1">
          <HeroSection />
          <FeaturedSection />
          <AmbiencePreview />
          <LocationsQuickView />
          <TestimonialsSection />
          {/* <CTASection /> */}
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Homepage;
